import { render, staticRenderFns } from "./_uuid.vue?vue&type=template&id=c88e9b56"
import script from "./_uuid.vue?vue&type=script&lang=js"
export * from "./_uuid.vue?vue&type=script&lang=js"
import style0 from "./_uuid.vue?vue&type=style&index=0&id=c88e9b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports